import skill1 from './generated/skills-1.json'
import skill2 from './generated/skills-2.json'
import skillSpriteMap from './generated/skill-sprite-map.json'
import support1 from './generated/supports-1.json'
import support2 from './generated/supports-2.json'
import support3 from './generated/supports-3.json'
import support4 from './generated/supports-4.json'

type Kind = 'skills' | 'supports'
const skillPaths: Record<string, string> = { ...skill1, ...skill2 }
const supportPaths: Record<string, string> = { ...support1, ...support2, ...support3, ...support4 }
const skillSprite: Record<string, number> = skillSpriteMap
const SPRITE_TILE = 24
const SPRITE_COLUMNS = 16
const SKILL_ATLAS_WIDTH = 384
const SKILL_ATLAS_HEIGHT = 312
const SKILL_ATLAS_URL = '/assets/game/skill-icons-3.29.1.2.webp'

function SameOriginSkillIcon({ index, size, fallback }: { index: number; size: number; fallback: string }) {
  const scale = size / SPRITE_TILE
  const column = index % SPRITE_COLUMNS
  const row = Math.floor(index / SPRITE_COLUMNS)
  return <span
    className="pp-game-icon pp-game-icon-sprite"
    role="img"
    aria-label=""
    style={{
      width: size,
      height: size,
      backgroundImage: `url(${SKILL_ATLAS_URL})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: `${SKILL_ATLAS_WIDTH * scale}px ${SKILL_ATLAS_HEIGHT * scale}px`,
      backgroundPosition: `${-column * SPRITE_TILE * scale}px ${-row * SPRITE_TILE * scale}px`,
    }}
  >
    <span className="pp-icon-fallback-underlay" aria-hidden="true">{fallback}</span>
  </span>
}

export function GameAssetIcon({ kind, id, size = 56, fallback = '?' }: { kind: Kind; id?: string; size?: number; fallback?: string }) {
  if (kind === 'skills' && id && skillSprite[id] !== undefined) {
    return <SameOriginSkillIcon index={skillSprite[id]} size={size} fallback={fallback} />
  }

  const src = id ? (kind === 'skills' ? skillPaths[id] : supportPaths[id]) : undefined
  if (!src) return <span className="pp-game-icon pp-game-icon-fallback" style={{ width: size, height: size }}>{fallback}</span>
  return <span className="pp-game-icon" style={{ width: size, height: size }}>
    <img src={src} alt="" width={size} height={size} loading="lazy" decoding="async" onError={(event) => { event.currentTarget.style.display = 'none' }} />
    <span className="pp-icon-fallback-underlay" aria-hidden="true">{fallback}</span>
  </span>
}
